import {Component, OnInit} from '@angular/core';
import {Melody} from "../../model/melody";
import {SubscriberService} from "../../services/subscriber.service";
import {catchError, of} from "rxjs";

@Component({
  selector: 'app-subscriber-favorites',
  templateUrl: './subscriber-favorites.component.html',
  styleUrls: ['./subscriber-favorites.component.css'],
  host: {
    class: 'app-page'
  }
})
export class SubscriberFavoritesComponent implements OnInit {
  favoriteMelodies: ReadonlyArray<Melody>;
  requestInProgress: boolean;

  constructor(private readonly subscriberService: SubscriberService) {
    this.favoriteMelodies = [];
    this.requestInProgress = false;
  }

  ngOnInit(): void {
    this.requestInProgress = true;
    this.subscriberService.getFavoriteMelodies()
      .pipe(catchError(() => of(new Array<Melody>())))
      .subscribe(melodies => {
        this.favoriteMelodies = melodies;
        this.requestInProgress = false;
      });
  }
}
